'use client';

import type { Advisor } from '@ria-client/advisor-search/types';
import { useState } from 'react';

import { AdvisorCard } from '../AdvisorCard/AdvisorCard';

export type ResultsListProps = {
  advisors: ReadonlyArray<Advisor>;
  startPosition?: number;
};

export function ResultsList({ advisors, startPosition = 1 }: ResultsListProps) {
  const [expandedCrd, setExpandedCrd] = useState<string | null>(null);

  if (advisors.length === 0) return null;

  return (
    <div className="flex flex-col gap-4">
      {advisors.map((advisor, index) => (
        <AdvisorCard
          key={advisor.crd}
          advisor={advisor}
          expanded={expandedCrd === advisor.crd}
          onToggle={() => setExpandedCrd(current => (current === advisor.crd ? null : advisor.crd))}
          position={startPosition + index}
        />
      ))}
    </div>
  );
}
